import { render, staticRenderFns } from "./ShipmentListModal.vue?vue&type=template&id=3d16d8f4&scoped=true&"
import script from "./ShipmentListModal.vue?vue&type=script&lang=ts&"
export * from "./ShipmentListModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentListModal.vue?vue&type=style&index=0&id=3d16d8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d16d8f4",
  null
  
)

export default component.exports